import axios from "axios";

export default axios.create({
    validateStatus: (status) => status < 500,
   // baseURL: 'http://toolsdev.pfscm.org'
  });
  
         
      
         
